import { render, staticRenderFns } from "./UsernameInput.vue?vue&type=template&id=3912097f&"
import script from "./UsernameInput.vue?vue&type=script&lang=js&"
export * from "./UsernameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports